import React from 'react'
import { useDispatch } from 'react-redux'
import { submit } from 'redux-form'

import { LocationAddModalWrapper } from 'Components/City/Page/Locations/Modals/LocationAddModalWrapper'
import { Modal } from 'Components/Modal'
import { ModalBody } from 'Components/Modal/ModalBody'
import { ModalFooter } from 'Components/Modal/ModalFooter'
import { ModalHeader } from 'Components/Modal/ModalHeader'
import { ModalTitle } from 'Components/Modal/ModalTitle'

import { LocationAddForm } from 'Containers/Form/City/Locations/LocationAdd'

import SubmitButton from '../../../../../../Components/Form/SubmitButton/index'
import { createLocation } from '../../../../../../Reducers/Location/actions'

const LocationAddModal = props => {
  const dispatch = useDispatch()
  const submitLocationAddForm = () => dispatch(submit('locationAddForm'))

  const { handleCancel, locationTypeOptions, modalShow } = props
  const handleFormSubmit = values => {
    /* TODO: API validation issues. */
    const { city, handleSuccess } = props
    const payload = {
      city_id: city.id,
      name: values.name,
      label: values.label,
      is_event: values.isEvent,
      type_id: values.typeId,
      latitude: values.coordinates.latitude,
      longitude: values.coordinates.longitude,
      moments_morning: values.moments.morning,
      moments_lunch: values.moments.lunch,
      moments_afternoon: values.moments.afternoon,
      require_permit: values.requirePermit,
      is_sheltered: values.isSheltered,
      status: 0,
    }
    const callbacks = {
      onSuccess: handleSuccess,
    }

    dispatch(createLocation(callbacks, city.id, payload))
  }
  return (
    <LocationAddModalWrapper>
      <Modal show={modalShow}>
        <ModalHeader closeButton onHide={handleCancel}>
          <ModalTitle>Add Location</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <LocationAddForm
            locationTypeOptions={locationTypeOptions}
            onSubmit={handleFormSubmit}
          />
        </ModalBody>
        <ModalFooter>
          <SubmitButton value="Cancel" onClick={handleCancel} />
          <SubmitButton value="Save" onClick={submitLocationAddForm} />
        </ModalFooter>
      </Modal>
    </LocationAddModalWrapper>
  )
}

export default LocationAddModal
